var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "viq-briefing" }, [
    _c("h3", { staticClass: "viq-briefing__title" }, [
      _vm._v("What should this report cover?"),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "viq-briefing__desc" }, [
      _vm._v(
        "\n    Describe the topic, jurisdictions, and scope for your board report. Be as specific as possible for better results.\n  "
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "viq-briefing__field" },
      [
        _c("el-input", {
          attrs: {
            type: "textarea",
            rows: 4,
            placeholder:
              "e.g., PSD3 implementation impact on payment processors across EU member states, focusing on licensing and operational requirements...",
            disabled: _vm.loading,
          },
          model: {
            value: _vm.topic,
            callback: function ($$v) {
              _vm.topic = $$v
            },
            expression: "topic",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "viq-briefing__actions" },
      [
        _c("el-button", { on: { click: _vm.goBack } }, [
          _vm._v("\n      Back\n    "),
        ]),
        _vm._v(" "),
        _c(
          "el-button",
          {
            attrs: {
              type: "primary",
              loading: _vm.loading,
              disabled: !_vm.topic.trim(),
            },
            on: { click: _vm.submit },
          },
          [_vm._v("\n      Generate Outline\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }